/* bl-cf-rec.js — Platzierungs-Tracking für Clean-Facts-Artikel.
 *
 * Beantwortet: Bei welcher Art von Thema wird WO geklickt?
 *
 * Erfasst jede Produkt-/Shop-Platzierung auf der Seite, nicht nur den eigenen Block:
 *   inline      Link im Fließtext
 *   block       die Empfehlungskachel (Variante 4 oder 5)
 *   related     "Verwandte Begriffe"
 *   outro       die "IMMER SCHÖN SAUBER BLEIBEN"-Sektion mit "Shop now"
 *   newsletter  Newsletter-Anmeldung
 *   sonstige    alles Übrige im Artikelbereich
 *
 * Ereignisse:
 *   bl_cf_read        einmal je Artikelaufruf, wenn der Artikel wirklich gelesen wurde
 *   bl_cf_impression  eine Platzierung war >=50% sichtbar, >=1s lang  (der Nenner!)
 *   bl_cf_click       eine Platzierung wurde geklickt
 *   bl_cf_exit        Seite verlassen — mit Bilanz, was gesehen und was geklickt wurde
 *
 * Ohne bl_cf_impression sind Klickzahlen wertlos: Ein Artikel mit 500 Lesern und 5 Klicks
 * sieht sonst besser aus als einer mit 20 Lesern und 4 Klicks.
 */
(function () {
  'use strict';

  var ctx = document.querySelector('[data-bl-cf-ctx]');
  if (!ctx || window.__blCfInit) return;
  window.__blCfInit = true;

  var A = {
    artikel:  ctx.dataset.blArticle  || '',
    stufe:    ctx.dataset.blStufe    || 'D',
    variante: parseInt(ctx.dataset.blVariante || '0', 10),
    thema:    ctx.dataset.blThema    || ''
  };

  var t0 = Date.now();
  var maxScroll = 0;
  var gesehen = Object.create(null);   // platz -> true
  var geklickt = [];                   // Protokoll für die Bilanz
  var bilanzGesendet = false;

  function sek() { return Math.round((Date.now() - t0) / 1000); }

  function track(name, params) {
    if (window.blIntern) return;
    var p = Object.assign({
      bl_artikel: A.artikel,
      bl_stufe:   A.stufe,
      bl_thema:   A.thema,
      bl_variante: A.variante,
      bl_dwell:   sek(),
      bl_scroll:  maxScroll
    }, params || {});
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, p));
    } catch (e) {}
  }

  /* ---------- Stile ----------
   * Liegen seit 06.09. in sections/index__artilcle-main.liquid, nicht mehr hier.
   * Von hier aus kamen sie erst nach dem Laden (defer) in den Head — der fertige
   * Text wurde bis dahin ungestylt gezeichnet. Nicht zurueckverlegen.
   */

  /* ---------- Scrolltiefe: sagt uns, ob Platzierung oder Angebot das Problem ist ---------- */
  function scrollTiefe() {
    var h = document.documentElement;
    var ganz = (h.scrollHeight - h.clientHeight);
    var pct = ganz > 0 ? Math.round((h.scrollTop || document.body.scrollTop) / ganz * 100) : 100;
    if (pct > maxScroll) maxScroll = Math.min(100, pct);
  }
  addEventListener('scroll', scrollTiefe, { passive: true });
  scrollTiefe();

  /* ---------- Platzierung eines Links bestimmen ---------- */
  function platzVon(el) {
    if (el.closest('[data-bl-platz]')) return el.closest('[data-bl-platz]').dataset.blPlatz;
    if (el.closest('[data-bl-cf-block]')) return 'block';
    if (el.closest('.article-related')) return 'related';
    if (el.closest('form[action*="/contact"]') ||
        el.closest('[class*="newsletter"]') ||
        el.closest('[id*="newsletter"]')) return 'newsletter';
    if (el.closest('.text-columns-with-icons') || el.closest('.ajb')) return 'outro';
    if (el.closest('.content.rte')) return 'inline';
    if (el.closest('footer') || el.closest('#shopify-section-footer')) return 'footer';
    if (el.closest('header') || el.closest('#shopify-section-header')) return 'nav';
    return 'sonstige';
  }

  function zielVon(href) {
    if (!href) return 'sonstige';
    if (href.indexOf('/products/') > -1) return 'produkt';
    if (href.indexOf('/collections/') > -1) return 'kollektion';
    if (href.indexOf('/blogs/') > -1) return 'artikel';
    if (href.indexOf('/pages/') > -1) return 'seite';
    return 'sonstige';
  }

  function handleVon(href) {
    var m = String(href || '').match(/\/(?:products|collections|blogs\/[^/]+)\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* ---------- Impressionen: der Nenner ---------- */
  var beobachtet = [
    ['block',      '[data-bl-cf-block]'],
    ['related',    '.article-related'],
    ['outro',      '.text-columns-with-icons'],
    ['newsletter', '[class*="newsletter"], [id*="newsletter"]']
  ];

  if ('IntersectionObserver' in window) {
    var timer = Object.create(null);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var platz = e.target.__blPlatz;
        if (!platz || gesehen[platz]) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          // erst nach 1s zählen — Durchscrollen ist kein Sichtkontakt
          timer[platz] = setTimeout(function () {
            if (gesehen[platz]) return;
            gesehen[platz] = true;
            track('bl_cf_impression', { bl_platz: platz });
          }, 1000);
        } else if (timer[platz]) {
          clearTimeout(timer[platz]); timer[platz] = null;
        }
      });
    }, { threshold: [0, 0.5, 1] });

    beobachtet.forEach(function (paar) {
      document.querySelectorAll(paar[1]).forEach(function (el) {
        if (el.__blPlatz) return;
        el.__blPlatz = paar[0];
        io.observe(el);
      });
    });
  }

  /* ---------- Gelesen: >=20s oder >=50% Scrolltiefe ---------- */
  var gelesenGesendet = false;
  function pruefeGelesen() {
    if (gelesenGesendet) return;
    if (sek() >= 20 || maxScroll >= 50) {
      gelesenGesendet = true;
      track('bl_cf_read', {});
      try { if (window.blHerkunft) window.blHerkunft.merke(); } catch (e) {}
    }
  }
  var leseTimer = setInterval(pruefeGelesen, 2000);
  addEventListener('scroll', pruefeGelesen, { passive: true });

  /* ---------- Klicks auf jede Platzierung ---------- */
  addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;

    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;

    var platz = platzVon(a);
    if (platz === 'nav' || platz === 'footer') return;   // Rauschen, nicht die Frage

    var ziel = a.dataset.blZiel || zielVon(href);
    var produkt = a.dataset.blProdukt || handleVon(href);

    var daten = {
      bl_platz:   platz,
      bl_ziel:    ziel,
      bl_produkt: produkt,
      bl_pos:     parseInt(a.dataset.blPos || '0', 10),
      bl_preis:   parseFloat(a.dataset.blPreis || '0') || 0,
      bl_gesehen: gesehen[platz] ? 1 : 0
    };
    track('bl_cf_click', daten);
    geklickt.push(platz + ':' + ziel);

    // Nur kommerzielle Ziele merken — Artikel-zu-Artikel ist kein Kaufweg.
    if (ziel === 'produkt' || ziel === 'kollektion') merkeHerkunft(platz, produkt, ziel);
  }, true);

  /* ---------- Herkunft merken + an den Warenkorb hängen ----------
   * Damit ein späterer Kauf zuordenbar wird — unabhängig von GA4 und Consent.
   * Das Attribut beginnt mit "_" und ist damit im Checkout unsichtbar,
   * taucht aber an der Bestellung auf und ist über die Admin-API auswertbar.
   */
  function merkeHerkunft(platz, produkt, ziel) {
    var stempel = [A.artikel, A.stufe, A.variante, platz, ziel, produkt, sek()].join('|');
    try {
      sessionStorage.setItem('_bl_rec_last', stempel);
      if (!localStorage.getItem('_bl_rec_first')) {
        localStorage.setItem('_bl_rec_first', stempel + '|' + new Date().toISOString().slice(0, 10));
      }
    } catch (e) {}

    // Warenkorb-Attribut sofort setzen: funktioniert auch bei leerem Korb und
    // überlebt die Navigation (keepalive).
    try {
      var erst = '';
      try { erst = localStorage.getItem('_bl_rec_first') || ''; } catch (e) {}
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '_bl_rec': stempel, '_bl_rec_first': erst } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- Bilanz beim Verlassen ----------
   * Der häufigste Ausgang ist "gesehen, nicht geklickt". Genau der fehlt sonst
   * in jeder Auswertung — und er ist die eigentliche Vergleichszahl.
   */
  function bilanz() {
    if (bilanzGesendet) return;
    bilanzGesendet = true;
    clearInterval(leseTimer);
    track('bl_cf_exit', {
      bl_gesehen_liste: Object.keys(gesehen).join(',') || 'keine',
      bl_klicks:        geklickt.join(',') || 'keine',
      bl_klick_anzahl:  geklickt.length,
      bl_block_gesehen: gesehen.block ? 1 : 0,
      bl_ohne_klick:    geklickt.length === 0 ? 1 : 0
    });
  }
  addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') bilanz();
  });
  addEventListener('pagehide', bilanz);
})();
